import codes from '../../libs/jquery-mask-plugin/phone-codes-slim-2.min'
import IMask from 'imask';

window.IMask = IMask;
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
window.appPhoneMask = window.appPhoneMask || (function () {

    const D = document
    const W = window
    const defaultMask = '0000000000000'

    function trigger(element, eventName, bubbles = true, cancelable = true) {
        if ("createEvent" in D) {
            let evt = D.createEvent("HTMLEvents");
            evt.initEvent(eventName, bubbles, cancelable);
            element.dispatchEvent(evt);
        } else {
            // IE 8
            let e = D.createEventObject();
            e.eventType = eventName;
            element.fireEvent('on' + e.eventType, e);
        }
    }

    function on(el, event, cb) {
        if (el) {
            let events = event.split(' ')
            el.forEach(function (elem) {
                events.forEach(function (e) {
                    elem.removeEventListener(e, cb)
                    elem.addEventListener(e, cb)
                })
            })
        }
    }

    function setValue(value, e, isTrigger = true) {
        e && e.preventDefault()
        this.value = value;
        if (this.dispatchMask) {
            this.dispatchMask.value = value;
        }
        isTrigger && trigger(this, 'input')
    }

    function pasteInputFix(e, value) {
        let numbers = value.replace(/[^0-9]/gim, '');
        let number1 = value.slice(0, 1);
        let number2 = value.slice(0, 2);
        if (number2 === '+8' && numbers.length > 5) {
            setValue.call(this, value.replace('+8', '+7'), e)
            return false
        }
        if (number1 === '8') {
            setValue.call(this, '+7' + numbers.slice(1, numbers.length), e)
            return false
        }
        if (number1 === '9') {
            setValue.call(this, '+7' + value, e)
            return false
        }

        if (numbers.indexOf('789') === 0 || numbers.indexOf('779') === 0) {
            setValue.call(this, '+7'+numbers.slice(2, numbers.length), e)
            return false
        }
        setValue.call(this, numbers, null, false)
        return true
    }

    function pasteInput(e) {
        let paste = (e.clipboardData || W.clipboardData).getData('text');
        if (paste.length) {
            pasteInputFix.call(this, e, paste)
        }
    }

    function keydownInput(e) {
        if (!this.value.length) {
            if (e.key === '8') {
                setValue.call(this, '+7', e)
                return true
            }
            if (e.key === '9') {
                setValue.call(this, '+79', e)
                return true
            }
        }
    }

    function input(e) {
        pasteInputFix.call(this, e, this.value)
    }


    function init() {
        let inputs = D.querySelectorAll('input[type="tel"]');
        // Russian Feature
        on(inputs, 'paste', pasteInput)
        on(inputs, 'keydown', keydownInput)
        on(inputs, 'input', input)

        inputs.forEach(function (elem) {
            if (elem.dispatchMask) {
                elem.dispatchMask.destroy();
            }

            elem.dispatchMask = IMask(elem, {
                    mask: [
                        {
                            placeholderChar: '',
                            mask: defaultMask,
                        }
                    ],
                    dispatch: function (appended, dynamicMasked) {
                        let value = elem.value;
                        let mask = codes.d

                        if (value) {
                            let numbers = value.replace(/[^0-9]/gim, '')
                            for (let i = codes.l; i > 0; i--) {
                                let test = numbers.slice(0, i)
                                let code = codes.c[test]
                                if (code) {
                                    if (code instanceof Object) {
                                        if (code.l && code.l[numbers.length + '']) {
                                            mask = code.l[numbers.length + '']
                                        } else {
                                            mask = code.m
                                        }
                                    } else {
                                        mask = code
                                    }
                                    break;
                                }
                            }
                        } else {
                            mask = defaultMask
                        }
                        return IMask.createMask({
                            placeholderChar: '',
                            mask: mask,
                        });
                    }
                }
            );
        })
    }

    init()
    return {
        init
    }
})()
